import { render, staticRenderFns } from "./DashboardBarDesign.vue?vue&type=template&id=0cf27f6c"
import script from "./DashboardBarDesign.vue?vue&type=script&lang=js"
export * from "./DashboardBarDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports